import { I18n } from "i18n-js";

const i18n = new I18n({
  en: {
    discount: {
      pageHeading: "Upload Discounts",
      rulesHeading: "Rules to follow while uploading a file",
      rulesToUpload: [
        "SKU ID: Must match an existing Watson SKU ID",
        "Discount Amount: It should be greater than 0, less than SRP",
        "Date format: dd-mm-yyyy",
        "Uploaded file size should not exceed 5 MB",
        "Please note: The discount amount will be subtracted from the SRP and the discounted price will reflect on the BA app between the duration of the time mentioned in the start date and end date",
        "To discontinue the discount, upload a new CSV with an updated end date",
        "To add a new discount for an SKU, upload a new CSV and it will append to the existing list",
        "To change the discount amount of an SKU item, upload a new CSV and it will update the discount amount accordingly.",
        "Please refer to the sample discount CSV file given below. Ensure that the CSV you upload is in the same format.",
      ],
      fileTemplateHeading: "File Template",
      fileTemplate: "Discount Sample.csv",
      downloadBtn: "Download",
      saveBtn: "Save",
      backBtn: "< Home",
    },

    pulloutLetterNames: {
      pageHeading:
        "Upload a CSV File to add Authorized Personnel for Pullout Letter",
      backBtn: "< Home",
      saveBtn: "Save",
    },
    login: {
      username: "Username",
      password: "Password",
      loginBtn: "Login",
    },
    home: {
      searchPlaceholder: "Search Watson Store by Name",
      stores: "Stores",
      sNo: "S.No.",
      name: "Name",
      actions: "Actions",
      resetPassword: "Reset Password",
      confirmMessage: "Are you sure you want to ",
      deactivate: "Deactivate",
      activate: "Activate",
      view: "View",
      loginCredentials: "the login credentials for the BA app at",
      createNewCredentials: "Create New Credentials",

      createNew: {
        resetPassword: "Reset Password",
        createNewCredentials: "Create",
        storeName: "Store Name: ",
        storeLocationCode: "Store Location Code: ",
        username: "Username: ",
        assignedAOM: "Assigned AOM: ",
        assignAOM: "Assign AOM ",
        submitBtn: "Submit",
        generatePassword: "Generate Password",
        backBtn: "< Back",
      },

      viewStore: {
        storeDetails: "Store Details",
        storeName: "Store Name: ",
        storeLocationCode: "Store Location Code: ",
        username: "Username: ",
        assignedAOM: "Assigned AOM: ",
        updateAOM: "Update AOM",
        updateBtn: "Update",
        backBtn: "< Back",
      },
    },

    mappingManagement: {
      backBtn: "< Home",
      createMapping: "Create Mapping",
      mappingSKUsToGWP: "Mapping SKUs to GWP",
      noMappingFound: "No Mapping Found",

      addNewMapping: {
        pageHeading: "Add New Mapping",
        backBtn: "< Home",
        saveBtn: "Save",
        selectGoodStock: "Select Good Stock SKU Category ",
        selectGoodStockSKU: "Select the Good Stock SKU ",
        selectGWP: "Select the GWP SKU ",
      },
      editMapping: {
        pageHeading: "Edit Mapping Details",
        backBtn: "< Back",
        updateBtn: "Update",
        goodStockHSID: "Good Stock HS ID: ",
        gwpHSID: "GWP HS ID: ",
        goodStockItemName: "Good Stock Item Name: ",
        gwpItemName: "GWP Item Name: ",
        goodStockWatsonID: "Good Stock Watson ID: ",
        gwpWatsonID: "GWP Watson ID: ",
        gwpSKU: "GWP SKU",
        clickToUpdate: "Click here to update",
      },
    },

    reconciliation: {
      pageHeading: "Reconciliation",
      statusTabTitle: "Reconciliation Status",
      historyTabTitle: "Reconciliation History",

      discrepanciesStatus: {
        processing:
          "A Reconciliation file is under process right now, another file cannot be uploaded until the current file is processed and resolved",

        confirmStatus: {
          approveBtn: "Approve",
          rejectBtn: "Reject",
          downloadBtn: "Download Processed File",
          confirmationMessage:
            "This action cannot be undone. Please make sure you have gone through the processed file and want to proceed with the changes.",
          processedFile:
            "Your file was processed. You can find the discrepancies found in the file below.",
          confirmation: "Confirmation",
          cancel: "Cancel",
          confirm: "Confirm",
        },

        uploadReconciliation: {
          rulesHeading: "Rules to follow while uploading a file",
          rulesToUpload: [
            `The CSV File should contain the following columns -
                        Sublocation Code (Same as present on Prism)
                        Sublocation Description (Same as present on Prism)
                        SKU ID (Watson SKU ID)
                        SKU Name
                        Watson Gross Sales
                        Watson Sales Units`,
            "Ensure that all the fields are correctly filled. If the file has any incorrect values or empty values, the file will be rejected",
            "Once you have uploaded a file and the discrepancies for reconciliation are approved, you will not be able to upload a file for the same date range again.",
            "Once you approve the discrepancies for reconciliation, the backend will perform the tasks in the night and you can view the status on the Reconciliation History Tab.",
            "Please ensure there are no duplicate values of the SKU Items for a store.",
            "Once reconciliation is complete, it cannot be undone.",
            "In case of a technical failure, you will receive an email with the details of the tasks that need to be performed to complete the reconciliation.",
          ],
          sampleCSV: "Reconciliation Sample.csv",
          downloadBtn: "Download",
          fileTemplateHeading: "File Template",
          startDate: "Start Date",
          endDate: "End Date",
          file: "File",
          uploadBtn: "Upload For Reconciliation",
        },
      },

      noHistory: "No history requests available",
    },

    requestManagement: {
      pageHeading: "Request Management",
      pendingTab: "Pending Requests",
      approvedTab: "Approved Requests",
      rejectedTab: "Rejected Requests",
      allRequestsTab: "All Requests",
      noPendingRequests: "No pending requests available",
      noApprovedRequests: "No approved requests available",
      noRejectedRequests: "No rejected requests available",
      noAllRequests: "No requests available",

      requestManagementView: {
        backBtn: "< Back",
        viewDetails: "View Details",
        transferRequestID: "Transfer Request ID: ",
        requestID: "Request ID: ",
        requestTime: "Request Time: ",
        storeName: "Store Name: ",
        requestType: "Type of Request: ",
        status: "Status: ",
        comment: "Comment: ",
        contactAdmin: " Contact the Admin to create the required mapping",
        approveBtn: "Approve",
        rejectBtn: "Reject",
      },
    },

    userManagement: {
      pageHeading: "User Management",
      backBtn: "< Home",
      createBtn: "Create",
      noDataFound: "No Data Found",

      userManagementCreate: {
        pageHeading: "Create New User",
        backBtn: "< Back",
        employeeName: "Employee Name",
        assignRole: "Assign Role",
        employeeEmail: "Employee Email",
        submitBtn: "Submit",
      },

      userManagementView: {
        backBtn: "< Back",
        userDetails: "User Details",
        employeeName: "Employee Name: ",
        username: "Username: ",
        assignedRole: "Assigned Role: ",
        updateRole: "Update Role",
        updateBtn: "Update",
        generatePassword: "Generate Password",
        email: "Email: ",
      },
    },

    replenishment: {
      replenishment: "Replenishment Alert",
      uploadTab: "Replenishment Monthly Coverage",
      mailTab: "Replenishment E-Mail",

      replenishmentUpload: {
        rulesHeading: "Rules to follow while uploading a file",
        rulesToUpload: [
          "Mapping of the monthly cover to the store/sublocation needs to be added to the CSV file.",
          "Store Code/Sublocation Code - Must match the existing Store Code on Prism. (It can be store_code from the table Store or subloc_code from the table Sublocation).",
          "Store Name/Sublocation Name - Must match the existing Store Name/Sublocation Name on Prism.",
          "Monthly Cover - This should be a value (Up to 2 decimal places)",
          "AOM Username - The username of the AOM for the store. This is required only for own stores. The AOM username should be created on the Admin Portal -> User Management.",
          "The file size should not exceed 5 MB.",
          "To change an existing Monthly Cover for a Store or Sublocation - Upload a new CSV file with the updated details.",
          "If a new Store or Sublocation needs to be added - Upload a new CSV file with the updated details.",
          "Please refer to the sample monthly coverage CSV file given below for Watson Stores (Sublocations) and Own Stores. Ensure that the CSV you upload is in the same format.",
        ],
        sampleCSV: "Replenishment Sample.csv",
        downloadBtn: "Download",
        fileTemplateHeading: "File Template",
        file: "File",
        uploadBtn: "Upload For Replenishment",
      },
      replenishmentMail: {
        pageHeading: "Emails for Replenishment Alerts",
        ownStoreEmail: "Email ID for Own Store",
        ecomPlatformEmail: "Email ID for Ecom Platform",
        watsonStoreEmail: "Email ID for Watson Store",
        warehouseEmail: "Email ID for Warehouse",
        submitBtn: "Submit",
      },
    },

    bulkUpload: {
      pageHeading: "Bulk Upload",
      statusTabTitle: "Status",
      historyTabTitle: "Past Uploads",
      noPastUploads: "No past uploads",
      noPastUploadsMessage: "No past uploads",
      uploadInitialInventoryFile: "Upload Initial Inventory File",
      downloadFile: "Download File",
      retry: "Retry",
      ongoingUpload: "Ongoing Upload",
      uploadCSV: "Upload CSV",
      fileUnderProcessingMessage:
        "Your file has been successfully uploaded and is being processed. A summary will be available shortly.",
      rulesTitle: "Rules to follow while uploading a file",
      rulesToUpload: [
        {
          title: "Required Columns for the CSV:",
          list: ["SKU Name", "SKU ID", "SUBLOCATION CODE", "QUANTITY"],
        },
        {
          title: "Guidelines:",
          list: [
            "Initial inventory can only be updated once per sublocation, so ensure the CSV is accurate.",
            "All pending transfers in the BA app must be completed before uploading initial inventory.",
            "Once initial inventory is uploaded, all item quantities will reflect the CSV data.",
            "The Sublocation Code must match the one in Prism.",
            "Quantity must be a positive whole number.",
            "All fields are mandatory.",
          ],
        },
        {
          title: "Recommendation:",
          list: [
            "Upload CSVs by sublocation.",
            "Upload at night to avoid slowing backend operations.",
          ],
        },
        {
          title: "Failure Handling:",
          list: [
            "If Prism fails, retry via the `Retry` button in Past Uploads.",
            "For incorrect SKU IDs (ALUs), update initial inventory manually through Prism.",
          ],
        },
      ],
    },
    replenishmentRequests: {
      pageHeading: "Replenishment Requests",
      pendingTab: "Pending Requests",
      approvedTab: "Approved Requests",
      rejectedTab: "Rejected Requests",
      allRequestsTab: "All Requests",
      noPendingRequests: "No pending requests available",
      noApprovedRequests: "No approved requests available",
      noRejectedRequests: "No rejected requests available",
      noAllRequests: "No requests available",

      requestDetails: {
        backBtn: "< Back",
        viewDetails: "View Details",
        transferRequestID: "Transfer Request ID: ",
        requestID: "Request ID: ",
        requestTime: "Request Time: ",
        storeName: "Store Name: ",
        approveBtn: "Approve",
        rejectBtn: "Reject",
        approvedTime: "Approved Time: ",
        rejectedTime: "Rejected Time: ",
      },
    },
  },
});
export default i18n;
